<div class="engine-camera-position">
    X:{{ camera?.x }} Y:{{ camera?.y }} Z:{{ camera?.z }} Dist:{{ camera?.dist }}
</div>